module.exports = __webpack_public_path__ + "static/img/02.521ad46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour2/02.jpg
// module id = l1UZ
// module chunks = 0